import { createApp } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faStar } from '@fortawesome/free-regular-svg-icons'
import { faGitAlt } from '@fortawesome/free-brands-svg-icons'
import App from './App.vue'
import router from './router'
import store from './store'

library.add(fas, faGitAlt, faStar)

let app = createApp(App)

app.config.globalProperties.$baseUrl =  url => {
  let baseURL = url;
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1"){
    baseURL = "http://localhost:3000"+url;
  }
  return baseURL;
}

app.config.globalProperties.$I18n = null;

fetch('/json/I18n.json')
  .then(res => res.json())
  .then(data => {
    app.config.globalProperties.$I18n = () => data; // objet disponible globalement
    app.use(store)
      .use(router)
      .component('fa', FontAwesomeIcon)
      .mount('#app')
  })
  .catch(err => console.error("Erreur chargement i18n:", err));
